import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl, UntypedFormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { ModalConfirmacaoService } from 'src/app/shared/services/modal-confirmacao.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { IDoctorCompany, IMedico } from '../models/doctor';
import { DoctorService } from '../services/doctor.service';
import { ListCompanyService } from '../services/listcompany.service';
import { CompanyService } from '../../companies/services/company.service';
import { ICompany, IListByFilterEmpresas } from '../../companies/models/company.interface';
import { SessionService } from 'src/app/shared/services/session.service';

@Component({
  selector: 'app-edit-doctor',
  templateUrl: './edit-doctor.component.html',
  styleUrls: ['./edit-doctor.component.scss']
})
export class EditDoctorComponent implements OnInit {
  medicoId?: string | null;
  ERoleAdminString = ERoleAdminString;
  opcoesCompany: ICompany[] = [];
  isDoctorActive = true;
  doctorCompanies: IDoctorCompany[] = [];

  formEditDoctor = new UntypedFormGroup({
    id: new UntypedFormControl('', [Validators.required]),
    name: new UntypedFormControl('', [Validators.required]),
    document: new UntypedFormControl('', [Validators.required]),
    phone: new UntypedFormControl('', [Validators.required]),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    comments: new UntypedFormControl(''),
    crm: new UntypedFormControl('', [Validators.required]),
    doctorCompanies: new UntypedFormArray([])
  });

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly doctorservice: DoctorService,
    private readonly toastService: ToastService,
    private readonly modalConfirmacao: ModalConfirmacaoService,
    private readonly companyService: CompanyService,
    private readonly sessionService: SessionService
  ) {}

  public ngOnInit(): void {
    this.medicoId = this.activatedRoute.snapshot.paramMap.get('id');

    if (this.medicoId) {
      this.carregarDetalhesMedicos(this.medicoId);
    }
  }

  get podeAdicionarEmpresa(): boolean {
    return this.formArrayCompanies.length === 0;
  }

  get formArrayCompanies(): UntypedFormArray {
    return this.formEditDoctor.get('doctorCompanies') as UntypedFormArray;
  }

  public carregarDetalhesMedicos(medicoId: string): void {
    this.formEditDoctor.get('id')!.patchValue(medicoId);

    this.doctorservice.detalheMedico(medicoId).subscribe((res) => {
      if (res.messages && res.messages.length > 0) {
        this.toastService.toast(res.messages);
      }
      if (res.isSucceed) {
        this.formEditDoctor.get('name')!.patchValue(res.data.name);
        this.formEditDoctor.get('document')!.patchValue(res.data.document);
        this.formEditDoctor.get('email')!.patchValue(res.data.email);
        this.formEditDoctor.get('comments')!.patchValue(res.data.comments);
        this.formEditDoctor.get('phone')!.patchValue(res.data.phone);
        this.formEditDoctor.get('crm')!.patchValue(res.data.crm);

        this.isDoctorActive = !!res.data.active;

        if (res.data.doctorCompanies && res.data.doctorCompanies.length > 0) {
          this.doctorCompanies = res.data.doctorCompanies;
          res.data.doctorCompanies.forEach((companies) => {
            this.adicionarEmpresa(companies);
          });
        }

        this.getListCompany();
      }
    });
  }

  public editarMedico(): void {
    if (this.formEditDoctor.valid) {
      const addMedico: IMedico = {
        id: this.formEditDoctor.get('id')!.value,
        name: this.formEditDoctor.get('name')!.value,
        document: this.formEditDoctor.get('document')!.value,
        phone: this.formEditDoctor.get('phone')!.value,
        email: this.formEditDoctor.get('email')!.value,
        crm: this.formEditDoctor.get('crm')!.value,
        comments: this.formEditDoctor.get('comments')!.value,
        doctorCompanies: this.formArrayCompanies.getRawValue()
      };

      this.doctorservice.editarMedico(addMedico).subscribe((res) => {
        if (res.messages && res.messages.length > 0) {
          this.toastService.toast(res.messages);
        }

        if (res.isSucceed) {
          this.router.navigateByUrl('/dash/medicos');
        }
      });
    }
  }

  public desativarMedico(): void {
    this.modalConfirmacao
      .abrirModalConfirmacao({
        mensagem: `Tem certeza que deseja desativar o Atendente?`
      })
      .subscribe((resposta) => {
        if (!resposta) return;

        this.doctorservice.desativarMedico(this.medicoId!).subscribe((resposta) => {
          if (resposta.messages && resposta.messages.length > 0) {
            this.toastService.toast(resposta.messages);
          }

          if (resposta.isSucceed) {
            this.router.navigateByUrl('/dash/medicos');
          }
        });
      });
  }

  public ativarMedico(): void {
    this.modalConfirmacao
      .abrirModalConfirmacao({
        mensagem: `Tem certeza que deseja ativar o Atendente?`
      })
      .subscribe((resposta) => {
        if (!resposta) return;

        this.doctorservice.ativarMedico(this.medicoId!).subscribe((resposta) => {
          if (resposta.messages && resposta.messages.length > 0) {
            this.toastService.toast(resposta.messages);
          }

          if (resposta.isSucceed) {
            this.router.navigateByUrl('/dash/medicos');
          }
        });
      });
  }

  public getListCompany(): void {
    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;

    const filtros: IListByFilterEmpresas = {
      pageNumber: 0,
      pageSize: 99999,
      active: true
    };

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (companyId) {
      filtros.companyId = companyId;
    }

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    this.companyService.listarTodasEmpresas(filtros).subscribe((resposta) => {
      const filtredCompanies = this.doctorCompanies.filter((doctorCompany) => {
        return !resposta.data.some((company) => company.id === doctorCompany.companyId);
      });

      const filtredCompaniesFormatted: any[] = filtredCompanies.map((value) => ({
        ...value.company,
        name: value.company.name,
        id: value.companyId
      }));

      this.opcoesCompany = [...resposta.data, ...filtredCompaniesFormatted];
      console.log([...resposta.data, ...filtredCompaniesFormatted]);
    });
  }

  public adicionarEmpresa(dadosEmpresa?: IDoctorCompany): void {
    let formGroupEmpresa;

    if (dadosEmpresa) {
      formGroupEmpresa = new UntypedFormGroup({
        companyId: new UntypedFormControl(dadosEmpresa.companyId, [Validators.required]),
        doctorCompanyEmail: new UntypedFormControl(dadosEmpresa.doctorCompanyEmail, [
          Validators.required,
          Validators.email
        ])
      });
    } else {
      formGroupEmpresa = new UntypedFormGroup({
        companyId: new UntypedFormControl(null, [Validators.required]),
        doctorCompanyEmail: new UntypedFormControl('', [Validators.required, Validators.email])
      });
    }

    this.formArrayCompanies.push(formGroupEmpresa);
  }

  public removerEmpresa(companyIndex: number): void {
    this.formArrayCompanies.removeAt(companyIndex);
  }
}
